/**
 * Esegue fn su ogni voce, al massimo `max` alla volta, e restituisce gli
 * esiti nello stesso ordine delle voci: { ok: true, valore } oppure
 * { ok: false, errore }. Una voce che fallisce non ferma le altre: decide
 * chi chiama.
 *
 * Serve al "Riapri" e al ritorno dal pagamento: i documenti arrivavano uno
 * dopo l'altro e l'attesa si sommava. Il tetto evita di chiedere al backend
 * dieci anteprime insieme (ne prepara comunque al massimo tre alla volta).
 */
export async function inParallelo(voci, max, fn) {
  const lista = Array.from(voci || []);
  const esiti = new Array(lista.length);
  let prossimo = 0;
  const lavora = async () => {
    while (prossimo < lista.length) {
      const i = prossimo++;
      try {
        esiti[i] = { ok: true, valore: await fn(lista[i], i) };
      } catch (errore) {
        esiti[i] = { ok: false, errore };
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(Math.max(1, max), lista.length) }, lavora));
  return esiti;
}
